import { config } from '../config';

const API_BASE_URL = config.vdrUrl || process.env.REACT_APP_VDR_URL || 'http://localhost:8080/api';
const COMPANY_ID = config.companyId || process.env.REACT_APP_COMPANY_ID || '';
const TOKEN_KEY = 'authToken';

function getAuthHeaders(contentType = 'application/json', withAuth = true) {
  const headers: Record<string, string> = {};

  if (contentType) {
    headers['Content-Type'] = contentType;
  }

  if (withAuth) {
    const token = sessionStorage.getItem(TOKEN_KEY);
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }

  return headers;
}

interface RequestOptions extends RequestInit {
  withAuth?: boolean; 
}

async function request<T = any>(
  endpoint: string,
  options: RequestOptions = {},
  contentType: string = 'application/json'
): Promise<T> {
  const { withAuth = true, ...fetchOptions } = options;

  const headers = {
    ...getAuthHeaders(contentType, withAuth),
    ...fetchOptions.headers,
  };

  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    ...fetchOptions,
    headers,
  });

  const text = await response.text();

  if (!response.ok) {
    throw new Error(text || 'Error while calling the API');
  }

  try {
    return JSON.parse(text);
  } catch {
    return text as T;
  }
}

export { request, COMPANY_ID, API_BASE_URL, getAuthHeaders };
